module.exports = __webpack_public_path__ + "f2408f9fcb36414585789d80fc40dee7.png";